export default "__VITE_ASSET__CJcbQTAE__"